function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2.721 17.116v-6.802m-.85 6.802h4.251M1.02 20.518h19.558M1.02 18.817h19.558M1.871 10.314h4.251m2.551 6.802h4.252m-4.252-6.802h4.252m-7.653 6.802v-6.802m4.252 6.802v-6.802m2.551 6.802v-6.802m3.401 6.802h4.252m-4.252-6.802h4.252m-3.401 6.802v-6.802m2.551 6.802v-6.802M1.995 7.852a.426.426 0 00.261.761h17.092a.426.426 0 00.263-.76l-8.523-6.688a.426.426 0 00-.524 0l-8.57 6.687z",
  stroke: "#FFF",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgPayment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22
  }, props), _ref);
}

export default SvgPayment;